import React from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Breadcrumbs, Heading } from '@digdir/designsystemet-react';
import { useTranslation } from 'react-i18next';

import { OmBoligenForm } from '../pages/omBoligen/form';
import { OmBoligenFormData } from '../pages/omBoligen/form/types';
import { useCreateV2025Registration } from '../hooks/useRegistrationV2025Form/useCreateV2025Registration';
import { useBuildingData } from '../../../hooks/useBuildingDetails/buildingDetailsHooks';
import { BuildingCard } from '../pages/omBoligen/buildingCard';
import { RegistrationCommonStep } from '../../../utils/navigation';
import { useGetUserInputReadOnly } from '../../registration/hooks/useGetUserInput';
import { fromUserInputToFormData } from '../pages/omBoligen/form/utils/dataMapper';
import { PageWrapper } from '../pages/solceller';
import { SoknadSteg } from '../../../components/registering/utils/registerEnums';

import { Stepper } from './stepper';
import { BreadcrumbsWrapper, MainContentWrapper, SidebarPageLayout, SidebarWrapper } from './styledComponents';
import { SidebarPageLoader } from './pageLoader';

export const NewEnergiplanPage = () => {
  const { buildingId, registrationToCopyId } = useParams();
  const { building, buildingLoading } = useBuildingData(buildingId);
  const { userInput, userInputLoading } = useGetUserInputReadOnly(registrationToCopyId);

  const { t } = useTranslation();

  const { createRegistration, createIsLoading } = useCreateV2025Registration();
  const navigate = useNavigate();

  const onSubmit = (formData: OmBoligenFormData) => {
    createRegistration(
      { formData: { ...formData, kommunenummer: building?.adresse.kommuneNummer }, soknadSteg: SoknadSteg.Steg1 },
      {
        onSuccess: (data) => {
          navigate(`../${data.registreringId}/${RegistrationCommonStep.VENTILATION}`);
        }
      }
    );
  };

  if (userInputLoading || buildingLoading) {
    return <SidebarPageLoader />;
  }

  if (!building) {
    return null;
  }

  const defaultValues = fromUserInputToFormData({ userInput });

  return (
    <SidebarPageLayout>
      <BreadcrumbsWrapper>
        <Breadcrumbs>
          <Breadcrumbs.Link asChild aria-label={t('registrering.back')}>
            <Link to={`/bygg/${building?.energiObjektId}`}>{t('registrering.back')}</Link>
          </Breadcrumbs.Link>
        </Breadcrumbs>
      </BreadcrumbsWrapper>
      <SidebarWrapper>
        <Stepper />
      </SidebarWrapper>
      <MainContentWrapper>
        <PageWrapper>
          <Heading level={1} data-size="lg">
            {t('registrering.heading')}
          </Heading>
          <BuildingCard building={building} />
          <OmBoligenForm
            onSubmit={onSubmit}
            isLoading={createIsLoading}
            buildingId={building.energiObjektId}
            defaultValues={defaultValues}
          />
        </PageWrapper>
      </MainContentWrapper>
    </SidebarPageLayout>
  );
};
